export default __webpack_public_path__ + "static/media/stage_04@2x.c0bb2133.png";